import { GetOrdersResult } from './orders.types'

export const sortOrders = (response: GetOrdersResult): GetOrdersResult => {
  const sortedOrders = [...response.orders].sort((a, b) => {
    // Primary: sort by orderId descending
    if (b.orderId !== a.orderId) {
      return b.orderId - a.orderId
    }
    return 0
  })

  return {
    ...response,
    orders: sortedOrders,
  }
}
